<template>
  <div class="unititle">
    <span>{{title}}</span>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    title: {
      type: String,
      default: () => ({})
    },
    isActiveSec:{
      type: Boolean,
      default: false
    },
    isWidth700:{
      type: Boolean,
      default: false
    },
    isWidth840:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    
  },
}
</script>
<style lang="scss" scope>
.unititle{
	text-align: center;
	font-size: 18px;
	line-height: 50px;
	background: url("~@/assets/images/newstyle/miniline.png") no-repeat;
	background-size: 100% 5px;
	background-position: 0 100%;
  color: #3EFFF4;
}
</style>